import { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import Modal from 'antd/lib/modal/Modal';
import Input from '../../components/Input/Input';
import orgService from '../../services/orgService';
import { useSelector } from 'react-redux';
import { Row } from 'antd';

const PolygonGroups = () => {
    const { token } = useSelector((state) => state);
    const os = new orgService();
    const [isModalOpen, setIsOpenModal] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [groupId, setGroupId] = useState(null);
    const [groupsList, setGroupsList] = useState([]);

    const closeModal = () => {
        setGroupId(null);
        setGroupName('');
        setIsOpenModal(false);
    };

    const onEdit = (id, name) => {
        setGroupId(id);
        setGroupName(name);
        setIsOpenModal(true);
    };

    const createGroup = async () => {
        os.setPolygonGroup(token, { id: groupId, name: groupName }).then(() =>
            fetchGroups()
        );
    };

    const fetchGroups = async () => {
        const res = await os.getPolygonGroup(token);
        setGroupsList(res);
        closeModal();
    };

    useEffect(() => {
        fetchGroups();
    }, []);

    return (
        <main className='Main'>
            <div className='pageBody'>
                <div className='pageBody-content'>
                    <Button text='Добавить' onClick={() => setIsOpenModal(true)} />
                    <div
                        className='pageBody-content'
                        style={{ paddingLeft: 0, marginTop: '20px', cursor: 'pointer' }}
                    >
                        {groupsList?.map((item) => (
                            <Row
                                className='row-custom'
                                onClick={() => onEdit(item.id, item.name)}
                                style={{
                                    backgroundColor: '#FFF',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '0 12px',
                                    alignItems: 'center',
                                    borderRadius: '16px',
                                    minHeight: '50px',
                                    minWidth: '250px',
                                }}
                            >
                                <p
                                    key={item.id}
                                    style={{
                                        display: 'block',
                                        marginBottom: 0,
                                    }}
                                >
                                    {item.name}
                                </p>
                                <span
                                    style={{
                                        display: 'block',
                                        marginBottom: 0,
                                        marginLeft: '13px',
                                        fontWeight: '500',
                                        color: 'GrayText',
                                    }}
                                >
                                    {item.count}
                                </span>
                            </Row>
                        ))}
                    </div>
                </div>
            </div>
            <Modal width={540} className='Modal' open={isModalOpen} onCancel={closeModal}>
                <h2 className='Modal__head'>Добавить группу полигонов</h2>
                <div className='Modal__form_row'>
                    <Input
                        maskType={String}
                        shadow={true}
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        placeholder={'Название группы'}
                    />
                </div>
                <div
                    className='Modal__form_row'
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Button
                        text='Создать'
                        onClick={() => createGroup()}
                        disabled={!groupName}
                    />
                </div>
            </Modal>
        </main>
    );
};

export default PolygonGroups;
